import { differenceInCalendarDays } from 'date-fns';

type GameDateFormat = 'time' | 'weekday' | 'weekdayAndDay';

const MAX_WEEKDAY_DAYS = 5;
const EARLY_MORNING_END_HOUR = 8;

export const getGameDateFormat = (
  date: Date,
  now: Date = new Date()
): GameDateFormat => {
  const days = differenceInCalendarDays(date, now);

  if (days <= 0) {
    return 'time';
  }
  if (days === 1 && date.getHours() < EARLY_MORNING_END_HOUR) {
    return 'time';
  }
  if (days <= MAX_WEEKDAY_DAYS) {
    return 'weekday';
  }
  return 'weekdayAndDay';
};
